<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="card-title mb-0">{{ pageTitle }}</h4>
            <small class="text-muted">默认显示已付款且未入库，点上方阶段可看已入库后的订单(기본은 결제 완료·입고 전 건, 위 단계를 누르면 입고 뒤 건도 봅니다)</small>
          </div>
          <div class="card-body">
            <!-- 진행 단계 카드 — 숫자 = 그 단계의 결제완료 건. 누르면 이 목록을 그 단계로 거른다(입고 뒤 단계 포함),
                 다시 누르거나 ✕ 면 기본(미입고·미처리 = 구매완료·배송중·배송완료·입고대기) — 2026-10-07 YZY -->
            <CoupassStageCards ref="stageCards" paid :active="stage" :startdate="startdate" :enddate="enddate" :companyid="companyid"
                               @select="selectStage" />
            <!-- 탭 — 已入仓 = 入仓登记 으로 입창 위치가 저장된 건(2026-10-03 YZY). 기본 탭은 기존 목록 그대로 -->
            <b-nav tabs class="mb-2">
              <b-nav-item :active="tab === ''" @click="setTab('')">订单列表<small>(구매리스트)</small></b-nav-item>
              <b-nav-item :active="tab === 'Y'" @click="setTab('Y')">已入仓<small>(입창완료)</small></b-nav-item>
            </b-nav>
            <!-- 필터 -->
            <div class="d-flex flex-wrap align-items-center mb-3" style="gap:8px">
              <label class="mb-0 small">求购日期(요청일)</label>
              <input type="date" v-model="startdate" class="form-control form-control-sm" style="width:150px">
              <span>~</span>
              <input type="date" v-model="enddate" class="form-control form-control-sm" style="width:150px">
              <label class="mb-0 small ml-2">货主(업체)</label>
              <input type="text" v-model.trim="companyid" list="paidOrderCompanyList" placeholder="全部(전체)"
                     class="form-control form-control-sm" style="width:160px" @keyup.enter="search">
              <datalist id="paidOrderCompanyList">
                <option v-for="c in companyOptions" :key="c" :value="c"></option>
              </datalist>
              <label class="mb-0 small ml-2">状态(상태)</label>
              <div class="btn-group btn-group-sm flex-wrap" role="group">
                <button type="button" :class="['btn', !statusSel.length ? 'btn-primary' : 'btn-outline-primary']" :disabled="!!stage" @click="statusSel = []">全部<small>(전체)</small></button>
                <button v-for="o in statusOptions.slice(1)" :key="'so' + o.value" type="button" :disabled="!!stage"
                        :class="['btn', statusSel.includes(o.value) ? 'btn-primary' : 'btn-outline-primary']" @click="toggleStatusSel(o.value)">{{ o.text }}</button>
              </div>
              <b-badge v-if="stage" variant="primary" class="p-2">
                阶段(단계): {{ statusText(stage) }}
                <a href="#" class="text-white ml-1" title="默认(기본 보기)" @click.prevent="selectStage('')">✕</a>
              </b-badge>
              <b-button size="sm" variant="outline-primary" @click="batchOpen = true">批量订单号<small>(번호 여러 개)</small><b-badge v-if="batchTokens.length" variant="primary" class="ml-1">{{ batchTokens.length }}</b-badge></b-button>
              <b-button size="sm" variant="primary" @click="search" :disabled="loading">搜索<small>(검색)</small></b-button>
              <b-button size="sm" variant="success" @click="downloadExcel" :disabled="!rows.length">⬇ Excel<small>(엑셀 다운로드)</small></b-button>
              <span class="small text-muted">共 {{ rows.length }}件 · {{ totalQty }}个</span>
              <span v-if="filterActive" class="small text-primary">
                筛选(필터) {{ filteredRows.length }}件
                <a href="#" class="ml-1" @click.prevent="clearColFilter">清除筛选(필터 해제)</a>
              </span>
              <span v-if="truncated" class="small text-danger">结果过多，仅显示前8000条，请缩小日期或选择货主(8000건까지만 — 날짜를 좁히거나 업체를 고르세요)</span>
            </div>

            <b-modal v-model="batchOpen" title="批量订单号(번호 여러 개 한번에 검색)" ok-title="筛选(적용)" cancel-title="关闭" @ok="applyBatch">
              <div class="small text-muted mb-1">一行一个（也可用逗号/空格分隔），最多500个。匹配 1688订单号·货主订单号·快递单号(한 줄에 하나, 쉼표·공백 가능, 최대 500개. 1688주문번호·화주주문번호·운송장번호와 일치)</div>
              <textarea v-model="batchText" rows="10" class="form-control form-control-sm" placeholder="5127843673346017511&#10;2610140131&#10;ZTO79039904541029"></textarea>
              <div v-if="batchTokens.length" class="small mt-2">
                当前已筛选(현재 적용) {{ batchTokens.length }}个 ·
                <span :class="batchMissing.length ? 'text-danger' : 'text-success'">未找到(목록에 없음) {{ batchMissing.length }}个</span>
                <div v-if="batchMissing.length" class="text-danger" style="word-break:break-all">{{ batchMissing.join(', ') }}</div>
                <a href="#" @click.prevent="clearBatch">清除(해제)</a>
              </div>
            </b-modal>

            <div v-if="loading" class="text-center my-4"><b-spinner variant="primary"></b-spinner></div>

            <div v-else class="table-responsive paid-order-list">
              <table class="table table-sm table-bordered table-hover mb-0">
                <!-- 제목 2줄(제목·필터) 고정 — 필터 줄은 첫 줄 높이(headH)만큼 아래에 붙는다 -->
                <thead class="thead-light" :style="{ '--paid-head-h': headH + 'px' }">
                  <tr ref="headRow">
                    <th>下单日<br><small>(주문일)</small></th>
                    <th>付款日<br><small>(결제일)</small></th>
                    <th>货主<br><small>(업체)</small></th>
                    <th>组长负责人<br><small>(조장)</small></th>
                    <th>1688订单号<br><small>(1688주문번호)</small></th>
                    <th>商品<br><small>(상품)</small></th>
                    <th>数量<br><small>(주문수량)</small></th>
                    <th>商家发货日<br><small>(판매자 발송일)</small></th>
                    <th>物流/快递单号<br><small>(물류/운송장)</small></th>
                    <th>最新物流信息<br><small>(최신 물류)</small></th>
                    <th>状态<br><small>(상태)</small></th>
                    <th>入仓位置号<br><small>(입창위치)</small></th>
                    <th v-if="tab !== 'Y'">入仓时间<br><small>(입창시각)</small></th>
                    <th>经过<br><small>(경과일)</small></th>
                    <th>旺旺<br><small>(판매자 채팅)</small></th>
                    <th>备注<br><small>(메모)</small></th>
                    <template v-if="tab === 'Y'">
                      <th>登记时间<br><small>(등록시각)</small></th>
                      <th>登记人<br><small>(등록자)</small></th>
                      <th>补打<br><small>(재인쇄)</small></th>
                    </template>
                  </tr>
                  <!-- 열별 필터 — 불러온 목록 안에서 바로 거른다(서버 재조회 없음). 글자는 포함 검색 -->
                  <!-- 날짜·货主 는 지금 목록에 있는 값에서 고른다(下拉选择, 2026-10-04 YZY). 번호·상품처럼 값이 수천 개인 칸은 입력 검색 -->
                  <tr class="paid-order-list__filter">
                    <th>
                      <select v-model="colFilter.주문일" class="form-control form-control-sm">
                        <option value="">全部</option>
                        <option v-for="v in colOptions.주문일" :key="v" :value="v">{{ v }}</option>
                      </select>
                    </th>
                    <th>
                      <select v-model="colFilter.결제일" class="form-control form-control-sm">
                        <option value="">全部</option>
                        <option v-for="v in colOptions.결제일" :key="v" :value="v">{{ v }}</option>
                      </select>
                    </th>
                    <!-- 组长负责人 — 货主 ↔ 组长 표(客户和客户负责人 화면)에서 온 값 -->
                    <!-- 货主 는 골라도 되고 쳐도 된다(下拉+输入, 2026-10-04 YZY) — 친 글자가 들어간 货主 를 모두 보인다 -->
                    <th>
                      <input v-model.trim="colFilter.companyid" list="paidOrderColCompanyList" class="form-control form-control-sm" placeholder="全部">
                      <datalist id="paidOrderColCompanyList">
                        <option v-for="v in colOptions.companyid" :key="v" :value="v"></option>
                      </datalist>
                    </th>
                    <th>
                      <select v-model="colFilter.조장" class="form-control form-control-sm">
                        <option value="">全部</option>
                        <option value="__wait">等待分配组长</option>
                        <option v-for="l in leaderNames" :key="'ln' + l" :value="l">{{ l }}</option>
                      </select>
                    </th>
                    <th><input v-model.trim="colFilter.주문번호" class="form-control form-control-sm" placeholder="订单号/货主单号"></th>
                    <th><input v-model.trim="colFilter.상품" class="form-control form-control-sm" placeholder="商品名/选项/条码"></th>
                    <th></th>
                    <th>
                      <select v-model="colFilter.발송일" class="form-control form-control-sm">
                        <option value="">全部</option>
                        <option value="Y">已发货(발송됨)</option>
                        <option value="N">未发货(미발송)</option>
                      </select>
                    </th>
                    <th>
                      <input v-model.trim="colFilter.물류" class="form-control form-control-sm" placeholder="单号/快递">
                    </th>
                    <th>
                      <!-- 最新物流信息 다중선택(2026-10-18 崔凡 #77) — 고른 상태 중 하나라도 맞으면 보인다 -->
                      <b-dropdown size="sm" variant="outline-secondary" block menu-class="paid-order-list__tracemenu" toggle-class="form-control form-control-sm text-left" boundary="viewport">
                        <template #button-content><span class="small">{{ colFilter.최신.length ? colFilter.최신.length + '项已选' : '全部' }}</span></template>
                        <b-dropdown-form>
                          <b-form-checkbox-group v-model="colFilter.최신" :options="traceFilterOptions" stacked></b-form-checkbox-group>
                          <a v-if="colFilter.최신.length" href="#" class="small d-block mt-1" @click.prevent="colFilter.최신 = []">清除(해제)</a>
                        </b-dropdown-form>
                      </b-dropdown>
                    </th>
                    <th>
                      <select v-model="colFilter.상태" class="form-control form-control-sm">
                        <option value="">全部</option>
                        <option v-for="s in statusList" :key="s.value" :value="s.value">{{ s.text }}</option>
                      </select>
                    </th>
                    <th><input v-model.trim="colFilter.입창" class="form-control form-control-sm" placeholder="位置号 筛选"></th>
                    <th v-if="tab !== 'Y'"></th>
                    <th>
                      <select v-model="colFilter.경과" class="form-control form-control-sm">
                        <option value="">全部</option>
                        <option value="3">≥3天</option>
                        <option value="7">≥7天</option>
                      </select>
                    </th>
                    <th></th>
                    <th><input v-model.trim="colFilter.메모" class="form-control form-control-sm" placeholder="筛选 / * 有备注"></th>
                    <template v-if="tab === 'Y'">
                      <th></th>
                      <th></th>
                      <th></th>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="r in visibleRows" :key="r._id">
                    <td class="text-nowrap">{{ r._주문일 }}</td>
                    <td class="text-nowrap">{{ r._결제일 }}</td>
                    <td class="text-nowrap">{{ r.companyid }}</td>
                    <td class="text-nowrap"><b-badge v-if="leaderOf(r.companyid)" :style="Object.assign({ fontSize: '12px' }, tagStyle(leaderOf(r.companyid)))" class="px-2 py-1">{{ leaderOf(r.companyid) }}</b-badge><span v-else class="small text-danger">等待分配组长</span></td>
                    <td class="text-nowrap">
                      <div>{{ r._1688 }}</div>
                      <small v-if="r.화주주문번호" class="text-muted">货主 {{ r.화주주문번호 }}</small>
                    </td>
                    <td class="paid-order-list__name">
                      <div class="d-flex align-items-center" style="gap:6px">
                        <img v-if="r.옵션이미지 || r.등록이미지" :src="r.옵션이미지 || r.등록이미지" style="cursor:zoom-in" title="点击放大" @click.stop.prevent="lbUrl = r.옵션이미지 || r.등록이미지" loading="lazy" class="paid-order-list__pimg" alt="">
                        <div class="paid-order-list__nametext">
                          <div class="paid-order-list__clamp" :title="r.상품명">{{ r.상품명 }}</div>
                          <div class="small text-truncate">
                            <span v-if="r._옵션" class="text-danger">{{ r._옵션 }}</span>
                            <a v-if="r.구매링크" :href="r.구매링크" target="_blank" rel="noopener" class="ml-1">link</a>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="text-right text-nowrap">
                      {{ r._수량 }}
                      <small v-if="r.부분입고원수량 != null" class="d-block text-muted">剩余 / 原 {{ r.부분입고원수량 }}</small>
                    </td>
                    <td class="text-nowrap">{{ r._발송일 }}</td>
                    <!-- 物流/快递单号 — 행에서 바로 수정. 수동값은 1688 자동 동기화가 덮지 않는다(서버 물류정보.수동) -->
                    <td class="paid-order-list__waybill">
                      <div v-if="editing.id === r._id && editing.field === '운송장'" class="paid-order-list__edit">
                        <input v-model.trim="editing.code" class="form-control form-control-sm mb-1" placeholder="快递公司(택배사) 例 ZTO · 直达物流可只填公司名+件数 例 飞潮物流-B80-107件(단호 없으면 회사명+건수만)" maxlength="50">
                        <textarea v-model="editing.no" rows="3" class="form-control form-control-sm mb-1" style="min-width:260px" placeholder="快递单号(운송장번호) — 多个可用逗号、空格或换行分隔(여러 개는 쉼표·공백·줄바꿈)" maxlength="400" @keyup.esc="cancelEdit"></textarea>
                        <label v-if="r._1688" class="small mb-1 d-flex align-items-center" style="gap:4px">
                          <input type="checkbox" v-model="editing.sameOrder">同一1688订单全部适用(같은 1688주문 전체 적용)
                        </label>
                        <div class="d-flex" style="gap:4px">
                          <b-button size="sm" variant="primary" :disabled="saving" @click="saveEdit(r)">保存<small>(저장)</small></b-button>
                          <b-button size="sm" variant="light" :disabled="saving" @click="cancelEdit">取消</b-button>
                          <b-button v-if="r._수동" size="sm" variant="outline-secondary" :disabled="saving" @click="resetWaybill(r)" title="删除手动值，恢复1688自动值(수동값 삭제·1688 값으로)">恢复自动<small>(자동값)</small></b-button>
                        </div>
                      </div>
                      <div v-else class="d-flex align-items-start" style="gap:4px">
                        <div class="flex-grow-1">
                          <div v-for="(line, i) in (r._물류줄.length > 1 && !r._수동 && !expanded[r._id + '_n'] ? r._물류줄.slice(0, 1) : r._물류줄)" :key="i" class="text-nowrap">{{ line }}</div>
                          <!-- 1688 통보로 단호가 바뀔 때마다 목록에 쌓인다(옛 단호 포함) — 기본은 현재 단호만, 나머지는 펼쳐서(2026-10-18 崔凡) -->
                          <a v-if="r._물류줄.length > 1 && !r._수동" href="#" class="small text-nowrap" title="1688 单号变更时旧单号也会累积(1688 단호가 바뀌면 이전 번호도 쌓입니다)" @click.prevent="$set(expanded, r._id + '_n', !expanded[r._id + '_n'])">{{ expanded[r._id + '_n'] ? '▴ 收起' : '▾ 其他单号 ' + (r._물류줄.length - 1) + '个(이전·기타)' }}</a>
                          <span v-if="r._수동" class="badge badge-warning" :title="r._수동설명">手动(수동)</span>
                          <div v-if="r._수동 && r._물류자동" class="text-muted text-nowrap small" title="1688 自动同步值(1688 자동값)">1688: {{ r._물류자동 }}</div>
                        </div>
                        <b-button size="sm" variant="link" class="p-0 paid-order-list__pen" title="修改单号(운송장 수정)" @click="startEdit(r, '운송장')">✎</b-button>
                      </div>
                    </td>
                    <!-- 最新物流信息 — 1688 물류 통보로 저장된 최신 상태. 펼치면 받은 이력 전체 -->
                    <td class="paid-order-list__trace">
                      <template v-if="r._최신물류">
                        <a href="#" class="text-nowrap" @click.prevent="toggleTrace(r._id)">
                          <b-badge :style="tagStyle(r._최신물류.text)">{{ r._최신물류.text }}</b-badge>
                          <small class="text-muted ml-1">{{ r._최신물류.time }}</small>
                          <small>{{ expanded[r._id] ? '▴' : '▾' }}</small>
                        </a>
                        <ul v-if="expanded[r._id]" class="paid-order-list__timeline">
                          <li v-for="(t, i) in r._물류이력" :key="i"><small class="text-muted">{{ t.time }}</small> {{ t.text }}</li>
                        </ul>
                      </template>
                      <!-- 物流详情 — 1688 에 직접 물어 단계별 이력을 보여 준다(읽기 전용, 연락처 숫자는 서버가 가림) -->
                      <div v-if="r._1688">
                        <a href="#" class="small text-nowrap" @click.prevent="toggleDetail(r)">{{ detail[r._id] && detail[r._id].open ? '▴ 收起详情' : '▾ 物流详情(물류 상세)' }}</a>
                        <div v-if="detail[r._id] && detail[r._id].open" class="small">
                          <span v-if="detail[r._id].loading" class="text-muted">查询中…(조회 중)</span>
                          <span v-else-if="detail[r._id].error" class="text-danger">{{ detail[r._id].error }}</span>
                          <span v-else-if="!detail[r._id].traces.length" class="text-muted">暂无物流信息(아직 물류 정보가 없습니다)</span>
                          <div v-for="(tr, ti) in detail[r._id].traces" :key="ti">
                            <div v-if="tr.mailNo" class="text-muted">{{ tr.mailNo }}</div>
                            <ul class="paid-order-list__timeline">
                              <li v-for="(st, si) in tr.steps" :key="si"><small class="text-muted">{{ st.time }}</small> {{ st.text }}</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <template v-if="statusEdit.id === r._id">
                        <b-form-select v-model="statusEdit.to" :options="statusOptions.slice(4)" size="sm" class="mb-1"></b-form-select>
                        <div class="d-flex" style="gap:4px">
                          <b-button size="sm" variant="primary" :disabled="saving || !statusEdit.to || statusEdit.to === r.processStatus" @click="saveStatus(r)">保存<small>(저장)</small></b-button>
                          <b-button size="sm" variant="outline-secondary" :disabled="saving" @click="statusEdit = { id: '', to: '' }">取消<small>(취소)</small></b-button>
                        </div>
                      </template>
                      <template v-else>
                        <b-badge :variant="statusVariant(r.processStatus)">{{ statusText(r.processStatus) }}</b-badge>
                        <span v-if="r._상태수동" class="badge badge-warning" title="手动修改过状态(직원이 수동으로 고친 상태)">手动(수동)</span>
                        <span v-if="r._이상수동" class="badge badge-danger" title="员工手动标记的异常(직원이 수동으로 표시한 이상)">异常</span>
                        <b-button size="sm" variant="link" :class="['p-0 ml-1', r._이상수동 ? 'text-danger' : 'text-muted']" :disabled="saving" :title="r._이상수동 ? '取消异常标记(이상 표시 해제)' : '标记为异常(이상으로 표시)'" @click="toggleAbnormalMark(r)">⚑</b-button>
                        <b-button size="sm" variant="link" class="p-0 paid-order-list__pen" title="修改状态(상태 수정 — 앞 단계로만 바꿀 수 있습니다)" @click="statusEdit = { id: r._id, to: r.processStatus }">✎</b-button>
                      </template>
                    </td>
                    <!-- 入仓位置号 — 직원 전용(고객 화면에는 없음). 위치번호로 거를 수 있다 -->
                    <td class="text-nowrap font-weight-bold text-success">{{ r._입창위치 }}</td>
                    <td v-if="tab !== 'Y'" class="text-nowrap">{{ r._입창시각 }}</td>
                    <td class="text-right text-nowrap" :class="{ 'text-danger font-weight-bold': r._경과일 >= 7 }">{{ r._경과일 === '' ? '' : r._경과일 + '天' }}</td>
                    <td class="text-nowrap">
                      <a v-if="r._sellerOpenId" href="#" :title="r._판매자" @click.prevent="openWangwang(r)">旺旺</a>
                    </td>
                    <!-- 备注 — 행별 수동 메모 -->
                    <td class="paid-order-list__memo">
                      <div v-if="editing.id === r._id && editing.field === '메모'" class="paid-order-list__edit">
                        <textarea v-model="editing.memo" rows="2" class="form-control form-control-sm mb-1" maxlength="1000" @keyup.esc="cancelEdit"></textarea>
                        <div class="d-flex" style="gap:4px">
                          <b-button size="sm" variant="primary" :disabled="saving" @click="saveEdit(r)">保存<small>(저장)</small></b-button>
                          <b-button size="sm" variant="light" :disabled="saving" @click="cancelEdit">取消</b-button>
                        </div>
                      </div>
                      <div v-else class="d-flex align-items-start" style="gap:4px">
                        <div class="flex-grow-1" :title="r._메모설명">{{ r._메모 }}</div>
                        <b-button size="sm" variant="link" class="p-0 paid-order-list__pen" title="填写备注(메모 입력)" @click="startEdit(r, '메모')">✎</b-button>
                      </div>
                    </td>
                    <template v-if="tab === 'Y'">
                      <td class="text-nowrap">{{ r._입창시각 }}</td>
                      <td class="text-nowrap">{{ r._입창등록자 }}</td>
                      <td class="text-nowrap"><b-button size="sm" variant="outline-secondary" class="py-0 text-nowrap" @click="reprintLabel(r)">🖨️ 补打</b-button></td>
                    </template>
                  </tr>
                  <tr v-if="!filteredRows.length">
                    <td :colspan="tab === 'Y' ? 17 : 14" class="text-center text-muted py-4">没有数据(데이터가 없습니다)</td>
                  </tr>
                </tbody>
              </table>
              <!-- 수천 건을 한 번에 그리면 화면이 멈춘다 — 200건씩 더 보기(엑셀은 전체) -->
              <div v-if="filteredRows.length > visibleRows.length" class="text-center my-2">
                <b-button size="sm" variant="outline-secondary" @click="visibleCount += PAGE">显示更多(더 보기) {{ visibleRows.length }} / {{ filteredRows.length }}</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <inbound-label-print ref="printer"></inbound-label-print>
    <!-- 이미지 확대 — 페이지는 그대로 두고 위에 겹쳐 보여 준다(2026-10-19 崔凡 #98). 아무 데나 누르거나 Esc 로 닫는다 -->
    <div v-if="lbUrl" class="img-lightbox" @click="lbUrl = ''">
      <img :src="lbUrl" alt="">
    </div>
  </div>
</template>

<script>
import { coupassMenuTitle } from './coupassMenu';
import axios from 'axios';
import * as XLSX from 'xlsx';
import InboundLabelPrint from './InboundLabelPrint.vue';
import CoupassStageCards from './CoupassStageCards.vue';
import { processStatusText } from '@/utils/coupassStatusText';

// 서버 PAID_WAITING_STATUSES 와 같다 — 商品求购 진행현황의 구매완료(결제완료)·1688배송 단계 + 오류 처리 뒤 재입고 대기
const STATUSES = [
  { value: '구매완료', text: '已付款(구매완료)', variant: 'primary' },
  { value: '배송중', text: '运输中(배송중)', variant: 'info' },
  { value: '배송완료', text: '已签收(배송완료)', variant: 'success' },
  // 표시명은 이 화면만 「已入仓」(2026-10-03 YZY). 공유 라벨(coupassStatusText 의 入库待发)은 입고오류 리스트에서
  // 商家补发·换货 뒤 「재입고를 기다림」 뜻으로도 보이므로 건드리지 않는다. 저장값은 그대로 입고대기
  { value: '입고대기', text: '已入仓(입고대기)', variant: 'secondary' }
];
const EMPTY_COL_FILTER = { 조장: '', 주문일: '', companyid: '', 주문번호: '', 상품: '', 결제일: '', 발송일: '', 물류: '', 최신: [], 상태: '', 경과: '', 메모: '', 입창: '' };

// 1688 이 택배사 이름 대신 주는 DISTRIBUTOR_숫자 코드는 보이지 않게 한다(2026-10-18 崔凡 #77) — 운송장번호는 그대로
const shownCarrierCode = c => (/^DISTRIBUTOR_/i.test(String(c || '')) ? '' : (c || ''));

// 1688 물류 통보(LOGISTICS_BUYER_VIEW_TRACE)의 statusChanged — 서버 웹훅이 물류정보.물류상태 에 저장한다
const TRACE_STATUS = {
  CONSIGN: { text: '已发货(발송)', variant: 'info' },
  ACCEPT: { text: '已揽收(집하)', variant: 'info' },
  TRANSPORT: { text: '运输中(운송중)', variant: 'info' },
  DELIVERING: { text: '派送中(배송출발)', variant: 'primary' },
  SIGN: { text: '已签收(수령)', variant: 'success' },
  AGENT_SIGN: { text: '代签收(대리수령)', variant: 'success' },
  FAILED: { text: '派送失败(배송실패)', variant: 'danger' }
};

// 시각 → ms. 1688 웹훅 시각(msgSendTime)은 「YYYY-MM-DD HH:mm:ss」 중국시간 문자열, 서버가 찍은 시각은 ISO(Z)
function toMs(v) {
  if (v == null || v === '') return NaN;
  if (typeof v === 'number') return v;
  const s = String(v);
  if (/^\d+$/.test(s)) return parseInt(s);
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/.test(s)) return new Date(s.replace(' ', 'T') + '+08:00').getTime();
  return new Date(s).getTime();
}
function fmtMs(ms, withYear) {
  if (!Number.isFinite(ms)) return '';
  const d = new Date(ms);
  const p = n => String(n).padStart(2, '0');
  return (withYear ? d.getFullYear() + '-' : '') + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
}

export default {
  name: 'LogisPaidOrderListV0',
  components: { InboundLabelPrint, CoupassStageCards },
  data() {
    const today = new Date();
    const from = new Date(today.getTime() - 14 * 24 * 60 * 60 * 1000);
    return {
      lbUrl: '',   // 확대해 보는 상품 이미지
      pageTitle: coupassMenuTitle('logis.logispaidorderlist'),
      statusOptions: [{ value: '', text: '全部(전체)' }, { value: '__abnormal', text: '异常(이상)' }, { value: '__noin', text: '未入仓(未登记位置)' }, { value: '__in', text: '已入仓(已登记位置)' }].concat(STATUSES.map(s => ({ value: s.value, text: s.text }))),
      statusSel: [],   // 상태 다중선택 — 같은 종류(入仓 여부 / 진행 상태)끼리는 하나라도 맞으면, 다른 종류끼리는 모두 맞아야 보인다(2026-10-20 崔凡 #105: 已签收 + 未入仓)
      startdate: this.ymd(from),
      enddate: this.ymd(today),
      companyid: this.$route.query.companyid ? String(this.$route.query.companyid) : '',
      status: '',
      // 진행 단계 카드에서 고른 단계(processStatus) — '' = 기본(미입고·미처리). 고르면 서버에 stages 로 보낸다
      stage: '',
      // '' = 기존 목록, 'Y' = 已入仓(입창 위치가 저장된 건만)
      tab: this.$route.query.tab === 'arrived' ? 'Y' : '',
      companyOptions: [],
      rows: [],
      truncated: false,
      PAGE: 200,
      visibleCount: 200,
      loading: false,
      // 행 인라인 편집 — 한 번에 한 칸만
      editing: { id: '', field: '', code: '', no: '', memo: '', sameOrder: true },
      saving: false,
      expanded: {},
      detail: {}, // 행 _id → { open, loading, error, traces } — 物流详情(1688 조회 결과)
      colFilter: { ...EMPTY_COL_FILTER, 최신: [] },
      statusEdit: { id: '', to: '' },
      ownerLeader: {},
      batchOpen: false,
      batchText: '',
      batchTokens: [],
      statusList: STATUSES,
      // 고정 제목 첫 줄 높이(px) — 필터 줄이 그만큼 아래에 고정된다
      headH: 39,
      refreshTimer: null,
      quietBusy: false
    };
  },
  computed: {
    filterActive() {
      return Object.values(this.colFilter).some(v => (Array.isArray(v) ? v.length : v)) || this.batchTokens.length > 0 || this.statusSel.length > 0;
    },
    leaderNames() {
      return [...new Set(Object.values(this.ownerLeader))].sort((a, b) => a.localeCompare(b));
    },
    // 최신 물류 필터 선택지 — 지금 목록에 있는 상태만 + 「无物流信息」
    traceFilterOptions() {
      const seen = new Map();
      this.rows.forEach(r => { if (r._최신물류) seen.set(r._최신물류.text, true); });
      return [...seen.keys()].map(t => ({ value: t, text: t })).concat([{ value: '-', text: '无物流信息(물류정보 없음)' }]);
    },
    // 下拉 필터 선택지 — 지금 불러온 목록의 값(날짜는 최신순)
    colOptions() {
      const uniq = key => [...new Set(this.rows.map(r => r[key]).filter(Boolean))].sort();
      return { 주문일: uniq('_주문일').reverse(), 결제일: uniq('_결제일').reverse(), companyid: uniq('companyid') };
    },
    filteredRows() {
      const f = this.colFilter;
      if (!this.filterActive) return this.rows;
      const has = (v, q) => String(v == null ? '' : v).toLowerCase().includes(q.toLowerCase());
      return this.rows.filter(r => {
        if (this.statusSel.length && !this.statusMatch(r)) return false;
        if (f.조장 && this.leaderOf(r.companyid) !== (f.조장 === '__wait' ? '' : f.조장)) return false;
        if (f.주문일 && r._주문일 !== f.주문일) return false;
        if (f.companyid && String(r.companyid || '').toLowerCase().indexOf(f.companyid.toLowerCase()) < 0) return false;
        if (f.주문번호 && !has(r._1688, f.주문번호) && !has(r.화주주문번호, f.주문번호)) return false;
        if (f.상품 && !has(r.상품명, f.상품) && !has(r._옵션, f.상품) && !has(r.바코드, f.상품)) return false;
        if (f.결제일 && r._결제일 !== f.결제일) return false;
        if (f.발송일 === 'Y' && !r._발송일) return false;
        if (f.발송일 === 'N' && r._발송일) return false;
        if (f.물류 && !has(r._물류, f.물류) && !has(r._물류자동, f.물류)) return false;
        if (f.최신.length && !f.최신.some(v => (v === '-' ? !r._최신물류 : !!(r._최신물류 && r._최신물류.text === v)))) return false;
        if (this.batchTokens.length && !this.batchMatch(r)) return false;
        if (f.상태 && r.processStatus !== f.상태) return false;
        if (f.경과 && !(r._경과일 !== '' && r._경과일 >= Number(f.경과))) return false;
        // 「*」 = 메모가 있는 건만
        if (f.메모 === '*' && !r._메모) return false;
        if (f.메모 && f.메모 !== '*' && !has(r._메모, f.메모)) return false;
        if (f.입창 && !has(r._입창위치, f.입창)) return false;
        return true;
      });
    },
    visibleRows() {
      return this.filteredRows.slice(0, this.visibleCount);
    },
    // 批量订单号 중 이 목록에 없는 번호
    batchMissing() {
      if (!this.batchTokens.length) return [];
      const have = new Set();
      this.rows.forEach(r => this.batchKeys(r).forEach(k => have.add(k)));
      return this.batchTokens.filter(t => !have.has(t));
    },
    totalQty() {
      return this.rows.reduce((s, r) => s + (Number(r._수량) || 0), 0);
    }
  },
  watch: {
    // 필터가 바뀌면 처음 200건부터 다시
    colFilter: {
      deep: true,
      handler() { this.visibleCount = this.PAGE; }
    }
  },
  mounted() {
    this.loadOwnerLeader();
    this.search();
    // 入库完成·入库错误·待客户确认 으로 상태가 넘어간 건은 서버 목록에서 빠진다(已入仓 포함).
    // 이 화면을 띄워 둔 채 入库处理 에서 작업하고 돌아오면 바로 빠지게, 돌아올 때와 1분마다 조용히 다시 불러온다(2026-10-04 YZY)
    window.addEventListener('focus', this.quietRefresh);
    document.addEventListener('visibilitychange', this.quietRefresh);
    this.refreshTimer = setInterval(this.quietRefresh, 60 * 1000);
  },
  // 상단 탭(keep-alive)으로 숨겨진 동안은 자동 새로고침을 멈추고, 돌아오면 바로 한 번 조용히 불러온다
  activated() {
    if (this.refreshTimer) return;   // 처음 열릴 때는 mounted 가 이미 붙였다
    window.addEventListener('focus', this.quietRefresh);
    document.addEventListener('visibilitychange', this.quietRefresh);
    this.refreshTimer = setInterval(this.quietRefresh, 60 * 1000);
    this.quietRefresh();
  },
  deactivated() {
    window.removeEventListener('focus', this.quietRefresh);
    document.removeEventListener('visibilitychange', this.quietRefresh);
    if (this.refreshTimer) clearInterval(this.refreshTimer);
    this.refreshTimer = null;
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this._lbKey);
    window.removeEventListener('focus', this.quietRefresh);
    document.removeEventListener('visibilitychange', this.quietRefresh);
    if (this.refreshTimer) clearInterval(this.refreshTimer);
  },
  created() {
    this._lbKey = e => { if (e.key === 'Escape') this.lbUrl = ''; };
    window.addEventListener('keydown', this._lbKey);
  },
  methods: {
    ymd(v) {
      if (!v) return '';
      const d = new Date(typeof v === 'string' && /^\d+$/.test(v) ? parseInt(v) : v);
      if (isNaN(d.getTime())) return String(v).slice(0, 10);
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    },
    // 기본 4단계는 이 화면 표기, 카드로 고른 입고 뒤 단계는 쿠패스 공통 표기(중국어(한국어))
    statusText(v) {
      const s = STATUSES.find(x => x.value === v);
      if (s) return s.text;
      const zh = processStatusText(v);
      return zh && zh !== v ? zh + '(' + v + ')' : v;
    },
    statusVariant(v) {
      const s = STATUSES.find(x => x.value === v);
      return s ? s.variant : 'secondary';
    },
    toRow(r) {
      const 주문 = r.주문정보 || {};
      const 물류 = r.물류정보 || {};
      const 자동목록 = Array.isArray(물류.운송장번호목록) && 물류.운송장번호목록.length ? 물류.운송장번호목록 : (물류.운송장번호 ? [물류.운송장번호] : []);
      const 수동 = 물류.수동 && Array.isArray(물류.수동.운송장번호목록) && (물류.수동.운송장번호목록.length || 물류.수동.물류코드) ? 물류.수동 : null;
      // 운송장번호목록에는 손으로 넣은 번호도 더해져 있다(入库 스캔용) — 1688 값 표시에서는 뺀다
      const 수동번호 = new Set(수동 ? 수동.운송장번호목록 : []);
      // 현재 단호(최신 통보)를 맨 앞에 — 나머지는 이전·기타 단호
      const 자동번호 = 자동목록.filter(n => !수동번호.has(n) || n === 물류.운송장번호).sort((a, b) => (b === 물류.운송장번호) - (a === 물류.운송장번호));
      const 운송장 = 자동번호.join(', ');
      const 이력 = Array.isArray(물류.수동이력) ? 물류.수동이력 : [];
      const 메모 = r.구매리스트메모 || null;
      const 주문일 = 주문.주문시간 || r.주문시간 || r.요청일;
      const 결제일 = r.최종결제시간 || '';
      // 경과일 = 결제일(없으면 주문일)부터 오늘까지
      const base = new Date(결제일 || (typeof 주문일 === 'string' && /^\d+$/.test(주문일) ? parseInt(주문일) : 주문일));
      const days = isNaN(base.getTime()) ? '' : Math.max(0, Math.floor((Date.now() - base.getTime()) / 86400000));
      // 주문수량 = 이 건의 세트 수(구매요청수량). 부분입고면 남은 수량이다
      return {
        ...r,
        _주문일: this.ymd(주문일),
        _1688: 주문['1688주문번호'] || '',
        _옵션: [r.옵션1_중국어, r.옵션2_중국어].filter(Boolean).join(' '),
        _수량: parseInt(r.구매요청수량) || 0,
        _결제일: this.ymd(결제일),
        _이상수동: !!r.이상표시,
        _물류: 수동 ? [shownCarrierCode(수동.물류코드), 수동.운송장번호목록.join(', ')].filter(Boolean).join(' ') : [shownCarrierCode(물류.물류코드), 운송장].filter(Boolean).join(' '),
        // 화면은 번호마다 한 줄(긴 번호가 칸 안에서 꺾이지 않게)
        _물류줄: 수동
          ? (수동.운송장번호목록.length ? 수동.운송장번호목록.map((n, i) => (i === 0 && shownCarrierCode(수동.물류코드) ? shownCarrierCode(수동.물류코드) + ' ' : '') + n) : [shownCarrierCode(수동.물류코드)].filter(Boolean))
          : 자동번호.map((n, i) => (i === 0 && shownCarrierCode(물류.물류코드) ? shownCarrierCode(물류.물류코드) + ' ' : '') + n),
        _물류자동: [shownCarrierCode(물류.물류코드), 운송장].filter(Boolean).join(' '),
        _상태수동: (() => { const h = Array.isArray(r.processHistory) ? r.processHistory[r.processHistory.length - 1] : null; return !!(h && String(h.memo || '').includes('手动修改状态')); })(),
        _수동: 수동,
        _수동설명: 수동 ? ['手动修改(수동 수정): ' + fmtMs(수동.수정시간, true) + ' ' + (수동.수정자 || '')]
          .concat(이력.slice(-5).reverse().map(h => fmtMs(h.시간, true) + ' ' + (h.수정자 || '') + ': ' + (h.이전 || '-') + ' → ' + (h.이후 || '-'))).join('\n') : '',
        _발송일: this.ymd(toMs(물류.발송시간)),
        _최신물류: this.latestTrace(물류),
        _물류이력: this.traceHistory(물류),
        _sellerOpenId: (r.item && r.item.sellerOpenId) || '',
        _판매자: (r.item && r.item.companyName) || '',
        _메모: 메모 ? 메모.내용 : '',
        _메모설명: 메모 ? fmtMs(메모.수정시간, true) + ' ' + (메모.수정자 || '') : '',
        // 入仓登记(입창 등록) — 위치번호·시각·등록자
        _입창위치: (r.입창등록 && r.입창등록.위치번호) || '',
        _입창시각: r.입창등록 ? fmtMs(toMs(r.입창등록.등록일시), true) : '',
        _입창등록자: (r.입창등록 && r.입창등록.등록자) || '',
        _경과일: days
      };
    },
    // 최신 물류 — 물류 통보 상태(물류상태·업데이트시간). 통보가 아직 없으면 발송 통보(발송시간)로 「已发货」
    toggleStatusSel(v) {
      this.statusSel = this.statusSel.includes(v) ? this.statusSel.filter(x => x !== v) : this.statusSel.concat(v);
    },
    // 같은 축 안은 OR, 축끼리는 AND — 축: 이상 / 入仓 여부 / 진행 상태
    statusAxis(v) {
      return v === '__abnormal' ? 'a' : (v === '__noin' || v === '__in') ? 'i' : 's';
    },
    statusMatch(r) {
      const by = {};
      this.statusSel.forEach(v => { (by[this.statusAxis(v)] = by[this.statusAxis(v)] || []).push(v); });
      return Object.keys(by).every(k => by[k].some(v => this.statusHit(r, v)));
    },
    statusHit(r, v) {
      if (v === '__abnormal') return this.isAbnormal(r);
      if (v === '__noin') return !(r.입창등록 && r.입창등록.위치번호);
      if (v === '__in') return !!(r.입창등록 && r.입창등록.위치번호);
      return r.processStatus === v;
    },
    // 异常 — 물류 상태에 배송실패·假包裹·包裹不齐·派送异常 등이 잡히거나 입고오류 상태인 건(2026-10-19 崔凡 #77). 상태 문구 패턴으로 자동 판정
    isAbnormal(r) {
      if (r.이상표시) return true;   // 직원이 손으로 표시한 건
      const t = [r._최신물류 && r._최신물류.text, r.물류정보 && r.물류정보.물류상태].filter(Boolean).join(' ');
      if (r.processStatus === '입고오류' || /失败|异常|不齐|假包裹|拒收|退回|丢失|破损|滞留|FAILED/i.test(t)) return true;
      // 결제 후 3일이 지났는데 발송 흔적(발송시간·물류상태·운송장)이 없으면 이상(2026-10-20 崔凡 #77)
      const 물류 = r.물류정보 || {};
      const paid = r.최종결제시간 ? new Date(r.최종결제시간).getTime() : NaN;
      return !!(paid && !(r.입창등록 && r.입창등록.위치번호) && !물류.발송시간 && !물류.물류상태 && !물류.운송장번호 && Date.now() - paid >= 3 * 86400000);
    },
    toggleAbnormalMark(r) {
      const on = !r.이상표시;
      if (!on && !confirm('取消异常标记？(이상 표시를 해제합니다)')) return;
      this.saveRow(r, { _id: r._id, 이상표시: on });
    },
    latestTrace(물류) {
      if (물류.물류상태) {
        const s = TRACE_STATUS[물류.물류상태] || { text: 물류.물류상태, variant: 'secondary' };
        return { text: s.text, variant: s.variant, time: fmtMs(toMs(물류.업데이트시간)) };
      }
      if (물류.발송시간) return { text: '已发货(발송)', variant: 'info', time: fmtMs(toMs(물류.발송시간)) };
      return null;
    },
    // 펼침 — 서버에 쌓인 물류 관련 기록 전부(시간순, 최신이 위)
    traceHistory(물류) {
      const list = [];
      const add = (t, text) => { const ms = toMs(t); list.push({ ms: Number.isFinite(ms) ? ms : 0, time: fmtMs(ms, true), text }); };
      if (물류.발송시간) add(물류.발송시간, '商家发货(판매자 발송)');
      if (물류.부분발송시간) add(물류.부분발송시간, '部分发货(부분 발송)');
      const ch = 물류.운송장변경이력;
      if (ch && typeof ch === 'object') add(ch.eventTime, '单号变更(운송장 변경) ' + (ch.oldMailNo || '') + ' → ' + (ch.newMailNo || ''));
      if (물류.물류상태) add(물류.업데이트시간, '物流状态(물류 상태) ' + ((TRACE_STATUS[물류.물류상태] || {}).text || 물류.물류상태) + (물류.운송장번호 ? ' · ' + 물류.운송장번호 : ''));
      if (물류.수령확인시간) add(물류.수령확인시간, '确认收货(수령 확인)');
      (Array.isArray(물류.수동이력) ? 물류.수동이력 : []).forEach(h => add(h.시간, '手动修改单号(운송장 수동 수정) ' + (h.이후 || '-') + (h.수정자 ? ' · ' + h.수정자 : '')));
      return list.sort((a, b) => b.ms - a.ms);
    },
    // 조장·물류상태 태그 색 — 이름마다 다른 색(같은 이름은 항상 같은 색)(2026-10-19 崔凡 #101)
    tagStyle(name) {
      const P = [['#fde2e4', '#a4161a'], ['#fff1cc', '#8a5a00'], ['#dff3e4', '#1b7f3b'], ['#dbeafe', '#1d4ed8'], ['#fae8ff', '#a21caf'], ['#ffe8d6', '#b45309'], ['#d9f5f1', '#0f766e'], ['#e8e4ff', '#5b21b6'], ['#fde8f3', '#be185d'], ['#e5e7eb', '#374151']];
      let h = 0;
      String(name || '').split('').forEach(ch => { h = (h * 31 + ch.charCodeAt(0)) >>> 0; });
      const c = P[h % P.length];
      return { backgroundColor: c[0], color: c[1], fontWeight: 600 };
    },
    leaderOf(companyid) {
      return (this.ownerLeader && this.ownerLeader[companyid]) || '';
    },
    async loadOwnerLeader() {
      try {
        const { data } = await axios.post('/api/ownerLeader/map', {});
        if (data.요청결과 === '성공') this.ownerLeader = data.map || {};
      } catch (e) {
        console.error('组长负责人 표 읽기 실패:', e);
      }
    },
    clearColFilter() {
      this.colFilter = { ...EMPTY_COL_FILTER, 최신: [] };
      this.batchTokens = [];
      this.batchText = '';
    },
    // 批量订单号(2026-10-18 崔凡 #77) — 한 줄에 하나·쉼표·공백으로 붙여넣은 번호를 1688订单号·货主订单号·快递单号 와 맞춘다(대소문자 무시, 일치)
    parseBatch(text) {
      return [...new Set(String(text || '').split(/[\s,，;；、]+/).map(x => x.trim().toLowerCase()).filter(Boolean))].slice(0, 500);
    },
    batchKeys(r) {
      return [r._1688, r.화주주문번호, r._물류, r._물류자동].map(v => String(v == null ? '' : v).trim().toLowerCase()).filter(Boolean);
    },
    batchMatch(r) {
      const keys = this.batchKeys(r);
      return this.batchTokens.some(t => keys.includes(t));
    },
    applyBatch() {
      this.batchTokens = this.parseBatch(this.batchText);
      if (!this.batchTokens.length) this.batchText = '';
    },
    clearBatch() {
      this.batchTokens = [];
      this.batchText = '';
    },
    // 카드 선택/해제 — 서버에서 그 단계만 다시 받는다(입창 탭에서 누르면 订单列表 탭으로 돌아간다)
    selectStage(s) {
      this.stage = s || '';
      if (this.tab !== '') { this.setTab(''); return; }
      this.search();
    },
    // 서버 요청 본문 — search·quietRefresh 공용
    listBody() {
      return {
        companyid: this.companyid, start: this.startdate, end: this.enddate, status: this.statusSel.length === 1 && STATUSES.some(s => s.value === this.statusSel[0]) ? this.statusSel[0] : '', 입창: this.tab,
        ...(this.stage && this.tab === '' ? { stages: [this.stage] } : {})
      };
    },
    setTab(t) {
      if (this.tab === t) return;
      this.tab = t;
      if (t === 'Y') this.stage = '';
      this.$router.replace({ query: Object.assign({}, this.$route.query, { tab: t === 'Y' ? 'arrived' : undefined }) }).catch(e => {
        if (e && e.name !== 'NavigationDuplicated') console.error('订单列表 탭 주소 갱신 실패', e);
      });
      this.search();
    },
    // 已入仓 탭 재인쇄 — 入仓登记 라벨 그대로(등록한 위치번호), 1장
    reprintLabel(r) {
      this.$refs.printer.print([{ row: r, location: r._입창위치, qty: 1 }]);
    },
    toggleTrace(id) {
      this.$set(this.expanded, id, !this.expanded[id]);
    },
    async toggleDetail(r) {
      const cur = this.detail[r._id];
      if (cur && cur.open) { this.$set(this.detail, r._id, { ...cur, open: false }); return; }
      if (cur && cur.traces && !cur.error) { this.$set(this.detail, r._id, { ...cur, open: true }); return; }
      this.$set(this.detail, r._id, { open: true, loading: true, error: '', traces: [] });
      try {
        const { data } = await axios.post('/api/reqpurchase/logisticsTrace', { orderId: r._1688 });
        const ok = data && data['요청결과'] === '성공';
        this.$set(this.detail, r._id, { open: true, loading: false, traces: ok ? (data.traces || []) : [],
          error: ok ? '' : ((data && data.error && data.error.errorMessage) || '物流信息暂时查不到(물류 정보를 가져오지 못했습니다)') });
      } catch (e) {
        console.error('订单列表 物流详情 조회 오류:', e);
        this.$set(this.detail, r._id, { open: true, loading: false, traces: [], error: '网络错误,请稍后再试(네트워크 오류, 잠시 뒤 다시 눌러 주세요)' });
      }
    },
    async saveStatus(r) {
      const to = this.statusEdit.to;
      if (!to || to === r.processStatus) { this.statusEdit = { id: '', to: '' }; return; }
      this.saving = true;
      try {
        const { data } = await axios.post('/api/reqpurchase/updateProcessStatus', { _id: r._id, toStatus: to, memo: '订单列表 手动修改状态(수동 상태 수정)' });
        if (data.요청결과 === '실패' || data.error) {
          alert('修改失败(수정 실패): ' + (typeof data.error === 'string' ? data.error : ((data.error && (data.error.errorMessage || data.error.message)) || '')));
          return;
        }
        this.$set(r, 'processStatus', to);
        this.$set(r, '진행현황', to);
        this.$set(r, '_상태수동', true);
        this.statusEdit = { id: '', to: '' };
        this.$bvToast.toast('已修改', { title: '状态', variant: 'success', solid: true, autoHideDelay: 1500 });
      } catch (e) {
        console.error('주문리스트 상태 수정 오류:', e);
        alert('修改失败(수정 실패): ' + e.message);
      } finally {
        this.saving = false;
      }
    },
    startEdit(r, field) {
      const 수동 = r._수동;
      const 물류 = r.물류정보 || {};
      this.editing = {
        id: r._id,
        field,
        code: 수동 ? (수동.물류코드 || '') : (물류.물류코드 || ''),
        no: 수동 ? 수동.운송장번호목록.join('\n') : (Array.isArray(물류.운송장번호목록) && 물류.운송장번호목록.length ? 물류.운송장번호목록.join('\n') : (물류.운송장번호 || '')),
        memo: r._메모 || '',
        // 같은 1688 주문의 다른 행(같은 화주)에도 같이 — 기본 켬
        sameOrder: true
      };
    },
    cancelEdit() {
      this.editing = { id: '', field: '', code: '', no: '', memo: '', sameOrder: true };
    },
    async saveEdit(r) {
      const e = this.editing;
      const body = { _id: r._id };
      if (e.field === '운송장') {
        body.운송장 = { 물류코드: e.code, 운송장번호: e.no };
        body.같은주문적용 = !!e.sameOrder;
      }
      else if (e.field === '메모') body.메모 = e.memo;
      else return;
      await this.saveRow(r, body);
    },
    async resetWaybill(r) {
      if (!confirm('删除手动单号，恢复为1688自动值？(수동 운송장을 지우고 1688 값으로 되돌립니다)')) return;
      await this.saveRow(r, { _id: r._id, 운송장: null, 같은주문적용: !!this.editing.sameOrder });
    },
    async saveRow(r, body) {
      this.saving = true;
      try {
        const { data } = await axios.post('/api/reqpurchase/paidlist/update', body);
        if (data.요청결과 !== '성공') {
          alert('保存失败(저장 실패): ' + ((data.error && data.error.errorMessage) || ''));
          return;
        }
        // 목록은 freeze 돼 있어 바뀐 행(같은 1688 주문 전체 적용이면 여러 행)만 새로 만들어 바꿔 끼운다
        const changed = Array.isArray(data.rows) && data.rows.length ? data.rows : [{ _id: r._id, 물류정보: data.물류정보, 구매리스트메모: data.구매리스트메모, 이상표시: data.이상표시 }];
        const byId = new Map(changed.map(c => [String(c._id), c]));
        this.rows = Object.freeze(this.rows.map(x => {
          const c = byId.get(String(x._id));
          return c ? Object.freeze(this.toRow({ ...x, 물류정보: c.물류정보, 구매리스트메모: c.구매리스트메모, 이상표시: c.이상표시 })) : x;
        }));
        this.cancelEdit();
      } catch (err) {
        console.error('订单列表 저장 오류:', err);
        alert('保存错误(저장 오류): ' + err.message);
      } finally {
        this.saving = false;
      }
    },
    // 왕왕 — 입고오류 리스트와 같은 /api/alibaba/getWangwangUrl(판매자 openUid).
    // 응답을 기다린 뒤 여는 창은 팝업 차단에 걸리므로 빈 창을 먼저 연다
    async openWangwang(r) {
      const w = window.open('', '_blank');
      try {
        const { data } = await axios.post('/api/alibaba/getWangwangUrl', { toOpenUid: r._sellerOpenId });
        if (data.요청결과 === '성공' && data.result && w) {
          w.location.href = data.result;
          return;
        }
        console.error('왕왕 링크 실패:', data.error);
        if (w) w.close();
        alert('获取旺旺链接失败(왕왕 링크 실패)');
      } catch (e) {
        console.error('왕왕 링크 오류:', e);
        if (w) w.close();
        alert('获取旺旺链接失败: ' + e.message);
      }
    },
    syncHeadH() {
      this.$nextTick(() => {
        const r = this.$refs.headRow;
        if (r && r.offsetHeight) this.headH = r.offsetHeight;
      });
    },
    // 조용히 다시 불러오기 — 스피너·스크롤·필터·더보기 수는 그대로, 빠진 행만 사라진다. 편집 중·조회 중·창이 가려졌으면 건너뛴다
    async quietRefresh() {
      if (document.hidden || this.loading || this.saving || this.editing.id || this.quietBusy) return;
      this.quietBusy = true;
      try {
        const { data } = await axios.post('/api/reqpurchase/paidlist', this.listBody());
        if (data.요청결과 !== '성공') {
          console.error('订单列表 자동 새로고침 실패:', data.error);
          return;
        }
        // 응답을 기다리는 사이 편집·재조회가 시작됐으면 덮지 않는다
        if (this.editing.id || this.loading) return;
        this.truncated = !!data.truncated;
        this.rows = Object.freeze((data.rows || []).map(r => Object.freeze(this.toRow(r))));
      } catch (e) {
        console.error('订单列表 자동 새로고침 오류:', e);
      } finally {
        this.quietBusy = false;
      }
    },
    async search() {
      this.loading = true;
      if (this.$refs.stageCards) this.$refs.stageCards.load();
      try {
        const { data } = await axios.post('/api/reqpurchase/paidlist', this.listBody());
        if (data.요청결과 !== '성공') {
          alert('搜索失败(검색 실패): ' + ((data.error && data.error.errorMessage) || ''));
          this.rows = [];
          return;
        }
        // 창을 막는 alert 대신 화면 안 안내(기본 조회가 전체 업체라 자주 걸린다)
        this.truncated = !!data.truncated;
        // 읽기 전용 목록이라 반응형을 걸지 않는다(수천 건)
        this.rows = Object.freeze((data.rows || []).map(r => Object.freeze(this.toRow(r))));
        this.visibleCount = this.PAGE;
        const set = new Set(this.companyOptions);
        this.rows.forEach(r => { if (r.companyid) set.add(r.companyid); });
        this.companyOptions = [...set].sort();
      } catch (e) {
        console.error('결제완료 주문 목록 검색 오류:', e);
        alert('搜索错误(검색 오류): ' + e.message);
      } finally {
        this.loading = false;
        this.syncHeadH();
      }
    },
    downloadExcel() {
      const headers = ['下单日(주문일)', '付款日(결제일)', '货主(업체)', '1688订单号(1688주문번호)', '货主订单号(화주주문번호)', '商品名(상품명)', '选项(옵션)', '条码(바코드)',
        '商品链接(상품링크)', '下单数量(주문수량)', '商家发货日(판매자 발송일)', '物流/快递单号(물류/운송장)', '手动(수동)',
        '最新物流信息(최신 물류)', '状态(상태)', '经过天数(경과일)', '商家(판매자)', '备注(메모)', '入仓位置号(입창위치)', '入仓登记时间(입창 등록시각)'];
      const LINK_COL = headers.indexOf('商品链接(상품링크)');
      const aoa = [headers].concat(this.filteredRows.map(r => [
        r._주문일, r._결제일, r.companyid || '', r._1688, r.화주주문번호 || '', r.상품명 || '', r._옵션, r.바코드 || '',
        r.구매링크 ? 'link' : '', r._수량, r._발송일, r._물류, r._수동 ? 'Y' : '',
        r._최신물류 ? r._최신물류.text + ' ' + r._최신물류.time : '', this.statusText(r.processStatus), r._경과일, r._판매자, r._메모, r._입창위치, r._입창시각
      ]));
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      this.filteredRows.forEach((r, i) => {
        const cell = ws[XLSX.utils.encode_cell({ r: i + 1, c: LINK_COL })];
        if (r.구매링크 && cell) cell.l = { Target: r.구매링크, Tooltip: r.구매링크 };
      });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      const d = new Date();
      const stamp = d.getFullYear() + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0');
      XLSX.writeFile(wb, '已付款订单列表_' + stamp + '.xlsx');
    }
  }
};
</script>

<style lang="scss" scoped>
.paid-order-list {
  max-height: 72vh;
  overflow: auto;
  font-size: 0.8rem;

  // 행 압축 — 테마 기본 줄높이(≈1.8)·칸 여백 때문에 한 행이 4~6줄 높이가 됐다(1500px 화면에 4행).
  // 줄높이·여백을 줄이고, 상품명은 2줄로 자르고(전체는 title), 번호 칸은 줄바꿈을 막는다
  td,
  th {
    padding: 3px 5px !important; // 테마의 .table td { padding: 15px 20px !important } 를 이긴다
    line-height: 1.3;
    vertical-align: middle;
  }

  // 테마가 .table 에 overflow:hidden 을 줘서 sticky 가 안 먹었다(제목이 같이 스크롤됐다) — 표는 visible 로
  table {
    overflow: visible !important;
  }

  // 제목 고정 — 칸(th) 단위 sticky. 필터 줄은 첫 줄 높이(--paid-head-h) 아래에
  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
  }

  thead tr.paid-order-list__filter th {
    top: var(--paid-head-h, 39px);
  }

  th {
    white-space: nowrap;
    font-size: 0.75rem;
  }

  &__filter th {
    background: #f8f9fa;

    .form-control {
      height: 24px;
      padding: 0 4px;
      font-size: 0.72rem;
      min-width: 56px;
    }
  }

  &__name {
    min-width: 200px;
    max-width: 250px;
  }

  &__nametext {
    min-width: 0;
  }

  &__clamp {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-all;
  }

  &__pimg {
    width: 36px;
    height: 36px;
    object-fit: cover;
    flex: none;
  }

  &__waybill {
    min-width: 150px;
  }

  &__edit {
    min-width: 260px;
  }

  &__trace {
    min-width: 130px;
    max-width: 280px;
  }

  &__timeline {
    margin: 2px 0 0;
    padding-left: 14px;
    white-space: normal;
    word-break: break-all;
  }

  &__pen {
    line-height: 1;
    font-size: 0.95rem;
  }

  &__memo {
    white-space: pre-line;
    min-width: 120px;
    max-width: 220px;
    word-break: break-all;
  }
}
.img-lightbox { position: fixed; inset: 0; z-index: 2000; background: rgba(0,0,0,.72); display: flex; align-items: center; justify-content: center; cursor: zoom-out; }
.img-lightbox img { max-width: 90vw; max-height: 90vh; background: #fff; border-radius: 4px; }
</style>
